<template>
  <div class="home">
    <Headers></Headers>
    <div class="center">
      <div class="banner">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="(item, key) in bannerList" :key="key">
            <div
              v-if="key == 0"
              class="banner-layer"
              @click="onBannerBut(item)"
            ></div>
            <div v-if="key == 0" class="banner-text">
              用心教，快乐学
              <p>实用创新的课程体系，快乐学音乐</p>
            </div>
            <img v-bind:src="item.mobile_image" @click="onBannerBut(item)" />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div class="center-APP">
        <h3>音乐窝APP</h3>
        <div class="center-text">
          集在线音乐学习资源
          <p>分享交流社区及教辅平台为一体</p>
        </div>
        <p class="center-more" @click="toApp()">了解详情></p>
        <img
          src="../assets/img/home/smartphone.png"
        />
      </div>
      <div class="center-OSO">
        <h3>OSO智能运营管理系统</h3>
        <div class="OSO-text">
          琴行掌中管理利器：
          <p>实时监管教学进度，高效管理教务工作</p>
        </div>
        <p class="OSO-more" @click="onOsoData()">了解详情></p>
        <img
          src="https://aliyunosszs.musicwow.com/2162472091882341881cccc38850b718.png"
        />
      </div>
      <div class="center-teaching">
        <h3>音乐窝课程体系</h3>
        <div class="teaching-text">
          20多位专业教师3年专心研发课程体系，创建立体式循环课堂，让教学标准化、系统化
          <!-- <p>少儿钢琴、爵士鼓、非洲鼓、尤克里里7大系列  </p>
          <p>让教学系统化、标准化</p> -->
        </div>
        <p class="teaching-more" @click="onTeachingData()">了解详情></p>
        <img src="../assets/img/home/books.png" />
      </div>
      <div class="center-book">
        <h3>音乐窝智能互动课堂</h3>
        <div class="book-text">
          教学APP+音乐窝智能互动学习机
          <p>让老师轻松教，学生高效学</p>
        </div>
        <p class="book-more" @click="onBookMusiclData()">了解详情></p>
        <img src="https://aliyunosszs.musicwow.com/APPimg/home/home(3).png" />
      </div>
      <div class="center-musical">
        <h3>音乐窝乐器产品</h3>
        <div class="musical-text">
          星臣吉他、克莱文电吉他品牌支持
          <p>定制专属品质乐器，致力打造完整音乐产业生态圈</p>
        </div>
        <p class="musical-more" @click="onMusiclData()">了解详情></p>
        <img
          src="https://aliyunosszs.musicwow.com/static/images/uploads/20200319/53d2ea4af884880b89cd02eb495d98e5.png"
        />
      </div>
      <div class="center-map">
        <h3>全国连锁音乐教育</h3>
        <div class="map-text">音乐窝线下门店及在线学员遍布全国</div>
        <!-- <p class="map-more">了解详情></p> -->
        <div class="map-img">
          <img
            class="map1"
            src="https://aliyunosszs.musicwow.com/APPimg/home/map.png"
          />
          <img
            class="map2"
            src="https://aliyunosszs.musicwow.com/APPimg/home/map2.png"
          />
        </div>
      </div>
    </div>
    <div class="footerShow">
      <Footer></Footer>
    </div>
    <Fixed></Fixed>
  </div>
</template>

<script>
import Headers from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import Fixed from "@/components/leagueFixed.vue";
export default {
  name: "home",
  data() {
    return {
      bannerList: [],
      // type: 1,
      url: "",

      //swiper 配置
      swiperOption: {
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  components: {
    Headers,
    Footer,
    Fixed,
  },
  methods: {
    onOsoData() {
      this.$router.push({ name: "Admin" });
    },
    onTeachingData() {
      this.$router.push({ name: "Teaching" });
    },
    onMusiclData() {
      this.$router.push({ name: "Musicwow" });
    },
    onBookMusiclData() {
      this.$router.push({ name: "Teaching" });
    },
    onBannerBut(item) {
      // console.log(item)
      if (item.url) {
        window.location.href = item.url;
      }
    },
    toApp() {
      this.$router.push({ name: "MusicwowApp" });
    },
  },
  async mounted(item) {
    this.url = localStorage.url;
    let banner = await this.$API.getBanner({ type: 1 });
    // console.log(banner);
    this.bannerList = banner.data;
    sessionStorage.typeHide = 1;
  },
};
</script>
<style lang="sass" scoped>
.home
  width: 100%
  height: 100%
.center
  padding-top: 60px
  .banner
    position: relative
    height: 191px
    img
      height: 191px
    .banner-layer
      position: absolute
      width: 100%
      height: 98%
      background: rgba(0, 0, 0, 0.3)

    .banner-text
      position: absolute
      left: 50%
      top: 50%
      transform: translate(-50%,-50%)
      font-size: 22px
      color: #fff
      p
        font-size: 12px
        margin-top: 5px
  .center-APP
    background: url('https://aliyunosszs.musicwow.com/APPimg/home/bg-1.png') no-repeat
    background-size: contain
    margin-top: 50px
    h3
      font-size: 24px
    .center-text
      font-size: 12px
      color: #9E9E9E
      margin-top: 5px
    .center-more
      font-size: 12px
      color: #07D1AA
      margin-top: 10px
    img
  .center-OSO
    background: url('https://aliyunosszs.musicwow.com/APPimg/home/bg-2.png') no-repeat
    background-size: 100% 80%
    padding-top: 50px
    box-shadow: 0px -2px 12px 0px rgba(0,0,0,0.1)
    h3
      font-size: 24px
    .OSO-text
      font-size: 12px
      color: #9E9E9E
      margin-top: 5px
    .OSO-more
      font-size: 12px
      color: #07D1AA
      margin-top: 10px
    img
      width: 342px
      margin-left: 57px
      margin-top: 30px
  .center-teaching
    padding-top: 50px
    box-shadow: 0px -2px 12px 0px rgba(0,0,0,0.1)
    h3
      font-size: 24px
    .teaching-text
      font-size: 12px
      color: #9E9E9E
      margin-top: 5px
      padding: 40px
    .teaching-more
      font-size: 12px
      color: #07D1AA
      margin-top: 10px
    img
      margin-top: 40px
  .center-musical
    padding-top: 50px
    box-shadow: 0px -2px 12px 0px rgba(0,0,0,0.1)
    h3
      font-size: 24px
    .musical-text
      font-size: 12px
      color: #9E9E9E
      margin-top: 5px
    .musical-more
      font-size: 12px
      color: #07D1AA
      margin-top: 10px
    img
      margin-top: 40px
  .center-book
    padding-top: 50px
    box-shadow: 0px -2px 12px 0px rgba(0,0,0,0.1)
    h3
      font-size: 24px
    .book-text
      font-size: 12px
      color: #9E9E9E
      margin-top: 5px
    .book-more
      font-size: 12px
      color: #07D1AA
      margin-top: 10px
    img
      margin-top: 40px
  .center-map
    padding: 50px 0
    box-shadow: 0px -2px 12px 0px rgba(0,0,0,0.1)
    h3
      font-size: 24px
    .map-text
      font-size: 12px
      color: #9E9E9E
      margin-top: 5px
    .map-more
      font-size: 9px
      color: #07D1AA
      margin-top: 10px
    .map-img
      margin-top: 40px
      position: relative
      .map1
        position: absolute
.footerShow
  padding-bottom: 56px
</style>

